import ROUTES from 'router/routes';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

function useGetFooterLinks() {
  const { t } = useTranslation();

  return useMemo(() => {
    return [
      {
        label: 'Le service',
        links: [
          {
            label: t('global.rent_bike'),
            to: ROUTES.rentBike,
            params: { type: 'velo' },
          },
          {
            label: t('global.workshop'),
            to: ROUTES.workshop,
          },
          {
            label: t('global.repair_and_overhaul'),
            to: ROUTES.repairAndOverhaul,
          },
          {
            label: t('contact.contact_us'),
            to: ROUTES.contact,
          },
        ],
      },
      {
        label: t('global.my_account'),
        links: [
          {
            label: t('global.my_reservations'),
            to: ROUTES.myReservations,
          },
          {
            label: t('global.my_invoices'),
            to: ROUTES.myInvoices,
          },
        ],
      },
    ];
  }, []);
}

export default useGetFooterLinks;
